import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../common/temp/node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-设置",
  "use": "icon-设置-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-设置\">\n<path d=\"M15.3584 18.5469L6.6416 18.5469L2.28223 10.9961L6.6416 3.44629L15.3584 3.44629L19.7178 10.9961L15.3584 18.5469Z\" stroke=\"currentColor\" stroke-width=\"2.29565\" />\n<circle cx=\"10.9998\" cy=\"11.0037\" r=\"2.18336\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol